import React from "react";
import Img from "../image/one.jpg"
import Img2 from "../image/two.jpg"
import Img3 from "../image/text-.png"
import { Link } from "react-router-dom";

const Page404 = () => {
    return (
        <div className="noPaage">
            <div className="style">
                <section className="back"> <img src={Img3} alt="background" className="back" /></section>

                <section className="contain">
                    <div className="image">
                        <img src={Img} alt="one" />
                    </div>
                </section>
                <section className="contain sec">
                    <div className="image">
                        <img src={Img2} alt="two" />
                    </div>
                </section>
            </div>
            <div className="container">
                <section className="content">
                    <h1>404</h1>
                    <h3>Oooppss, This Page Is Not Found</h3>
                    <p>We're sorry, but the page you requested could not be found. </p>
                    <div>
                        <Link to="/"><button>Back to Home</button></Link>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default Page404